import { createBlock } from 'factories/block';

export const createContinueBtn = ({ ...props }) => {
  return createBlock('ContinueButton', 'Continue' as any, {
    props: {
      label: 'Continue',
      location: 'next',
      ...props,
    },
    meta: { subType: 'continue' },
  });
};
